import axios from 'src/utils/httpClients/axios';

import { HOST_API } from 'src/config';
import { Tag } from 'src/@types/tags/tag';
import { TagsFilter } from 'src/@types/tags/tagsFilter';
import { TagCreate, TagUpdate } from 'src/@types/tags/types';
import { PagedResponse } from 'src/@types/shared/pagedResponse';

// ----------------------------------------------------------------------

const baseUrl = `${HOST_API}tags`;

async function getPagedTags(filter: TagsFilter) {
  const response = await axios.get<PagedResponse<Tag>>(baseUrl, { params: { ...filter } });
  return response.data;
}

async function createTag(tag: TagCreate) {
  await axios.post(baseUrl, { ...tag });
}

async function editTag(tag: TagUpdate) {
  await axios.put(`${baseUrl}/${tag.id}`, { ...tag });
}

async function removeTag(id: number) {
  await axios.delete(`${baseUrl}/${id}`);
}

const tagService = {
  getPagedTags,
  createTag,
  editTag,
  removeTag,
};

export default tagService;
